// insert bigcommerce search form

var el_search = document.getElementById('nav-menu-item-9770');

el_search.innerHTML = '<form role="search" class="searchform" method="get" action="https://shop.gentexcorp.com/search.php?search_query="> \
	<input type="text" value="" placeholder="Search Products..." name="search_query" id="s"> \
	<label for="s" class="screen-reader-text">Search Products</label> \
	<button class="header_menu" type="submit" value="" ><span class="screen-reader-text">Submit search button</span></button> \
	</form><button class="searchForm__toggle js-searchFormToggle"><span class="screen-reader-text">Open search form</span> '

const searchModalToggle = document.querySelector('.js-searchFormToggle')
const searchModal = document.querySelector('.js-searchModal')
const searchInput = document.querySelector('.js-search-input')
const searchClose = document.querySelector('.js-search-close')

searchModalToggle.addEventListener('click', function(){
	if(	searchModal.classList.contains('-is-open')){
		searchModal.classList.remove('-is-open')
	} else {
		searchModal.classList.add('-is-open')
		searchInput.focus()
	}
})

searchClose.addEventListener('click', function() {
	if(searchModal.classList.contains('-is-open')){
		searchModal.classList.remove('-is-open')
		searchModalToggle.focus()
	}
})